// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__gHmjf","label":"TextInput_label__tQMSV","error":"TextInput_error__00c_g"};